import React from "react";
import { useParams } from "react-router";

interface StatsContextType {
  needsReviewText: string | null;
  setNeedsReviewText: (value: string | null) => void;
  resetNeedsReviewText: () => void;
}

const StatsContext = React.createContext<StatsContextType | undefined>(
  undefined
);

interface StatsProviderProps {
  children: React.ReactNode;
}

export const StatsProvider: React.FC<StatsProviderProps> = ({ children }) => {
  const [needsReviewText, setNeedsReviewText] = React.useState<string | null>(
    null
  );
  const { datasetId } = useParams();

  // Reset state when dataset changes
  React.useEffect(() => {
    setNeedsReviewText(null);
  }, [datasetId]);

  const resetNeedsReviewText = () => {
    setNeedsReviewText(null);
  };

  return (
    <StatsContext.Provider
      value={{ needsReviewText, setNeedsReviewText, resetNeedsReviewText }}
    >
      {children}
    </StatsContext.Provider>
  );
};

export const useStatsContext = () => {
  const context = React.useContext(StatsContext);
  if (context === undefined) {
    throw new Error("useStatsContext must be used within a StatsProvider");
  }
  return context;
};
